import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { PreferenceCatalog } from '../../../models/preference-catalog/preference-catalog.model';
import { PreferenceOption } from '../../../models/preference-option/preference-option.model';
import { PreferenceCatalogSerializer } from '../../../models/preference-catalog/preference-catalog-serializer.class';
import { CustomErrorHandlerService } from '../custom-error-handler.service';

@Injectable()
export class PreferenceCatalogService extends BaseApiService<PreferenceCatalog> {
  private readonly aiUrl: string = environment.api.API_ENDPOINT;

  constructor(private http: HttpClient) {
    super(
        http,
        null,
        "preferencecatalogs",
        new PreferenceCatalogSerializer(),
        new CustomErrorHandlerService());
  }

  /** Generate catalog items ({ code, value }) from a natural-language prompt via AI. */
  public aiGenerate(prompt: string): Observable<PreferenceOption[]> {
    return this.http.post<PreferenceOption[]>(`${this.aiUrl}/preferencecatalogs/ai`, { prompt });
  }
}
